import ChronService from './service';

const service = new ChronService();

export default service;
